import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { AbstractControl, FormBuilder, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { FormGroup, FormControl, NgForm, ReactiveFormsModule } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
import { APIPaymentService } from '../../_services/payment-dues/payment-dues.service';
import { APITemplateService } from '../../_services/template/API-template';
import { $ModalManagerService } from '../../../../_helpers/Modals/ModalManager.service';
import { Constants } from '../../../../_utils/Constants';
import { formatDate } from '@angular/common';
import { APIEntityService } from '../../_services/entity/API-entity';
import { GstRegistrationService } from '../../_services/gst-registration/gst-registration.service';

//below code for Current Data
const now = new Date();
const currentdate = formatDate(now, 'yyyy-MM-dd', 'en-US', '+0530');

@Component({
	selector: 'app-gst-registration',
	templateUrl: './gst-registration.component.html',
	styleUrls: ['./gst-registration.component.css']
})
export class GstRegistrationComponent implements OnInit {
	entity_id: any;
	entity_legalname: any;
	gst_number: any;
	address: any; //Vijay
	location: any;
	state: any;
	pincode: any;
	email_id: any;
	entity_comments: any;
	uploader: any;
	gstRegistrationForm: FormGroup;
	isValid: boolean = false;
	templateIds: Number[] = [];
	myfiles: any[] = [];
	rootVal: string = "";
	pePrefix: string = "";
	identifiedVal: string = "";
	submitted = false;
	disableForm: boolean = false;
	statejson: any = {
		"27": "Maharashtra",
		"09": "Uttar Pradesh"
	}
	gstmodel = { urn: "", entity_id: "", entity_legalname: "", gst_number: "", address: "", location: "", state: "", pincode: "", email_id: "", entity_comments: "", tds: "", }

	constructor(private fb: FormBuilder,
		private ps: APIPaymentService,
		private $modal: $ModalManagerService,
		private db: $DBManagerService,
		private _route: ActivatedRoute,
		private es: APIEntityService,
		private gs: GstRegistrationService,

		private router: Router) {
		this._route.params.subscribe((params) => {
			this.gstmodel.entity_id = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID);
			this.gstmodel.entity_legalname = this.db.get(Constants.SESSSION_STORAGE, Constants.ORG_NAME);
			this.gstmodel.email_id = this.db.get(Constants.SESSSION_STORAGE, Constants.Entity_EmailID);
		});
	}
	photoName: any;
	fileExtension: any;
	fileExtensionError: boolean = false;
	fileExtensionMessage: any;
	photoContent: any;
	fileSizeError1: boolean = false;
	fileSizeError2: boolean = false;
	selectedValueCat: String;
	entCheck;

	attachmentList: any = [];
	headerlist: any = [];
	languageshow: boolean = true;
	languageothershow: boolean = false;

	get f() { return this.gstRegistrationForm.controls; }

	

	ngOnInit() {
		this.gstRegistrationForm = this.fb.group({
			entity_id: ['', [Validators.required]],
			entity_legalname: ['', [Validators.required, Validators.maxLength(100), Validators.minLength(3)]],
			gst_number: ['', [Validators.required,this.validateGSTNum()]],//, this.validateGSTNum
			address: ['', [Validators.required, Validators.maxLength(250), Validators.minLength(5)]],
			location: ['', [Validators.required, Validators.maxLength(100), Validators.minLength(3)]],
			state: ['', [Validators.required]],
			pincode: ['', [Validators.required, Validators.pattern("^[1-9][0-9]{5}$")]],
			// Validators.maxLength(6), Validators.minLength(6)]],
			email_id: ['', [Validators.required]],
			uploader: ['', [Validators.required]],
			tds: ['', [Validators.required]],
			entity_comments: ['',],
		});
		this.gstRegistrationForm.controls['entity_id'].setValue(this.gstmodel.entity_id);
		this.gstRegistrationForm.controls['entity_legalname'].setValue(this.gstmodel.entity_legalname);
		this.gstRegistrationForm.controls['email_id'].setValue(this.gstmodel.email_id);
	}//end of oninit
	
	//Vijay- to get entity details from DLT 
	/*	getContentEntityDetails(entityID) {
			let data = {
				"entity_id": entityID,
			}
			this.es.getContentEntityDetails(data)
				.subscribe(r => {
					this.gstRegistrationForm.controls['entity_id'].setValue(r[0].id);
					this.gstRegistrationForm.controls['entity_id'].enable();
				})
		}*/

	/*	getenabledFieldsData() {
			this.gs.GetNewgstRegistration(this.entity_id).subscribe(result => {
				console.log("new data " + result);
				this.onChangeDataSource(result);
			})
		}*/

	//Retrieving state id and state from first two characters of GST ID
	// changeGST(e) {
	// 	console.log("event value", e.target.value)
	// 	if (e.target.value.length > 0) {
	// 		let stat = this.gs.getstates().filter((f) => {
	// 			return f.stateid == e.target.value.substr(0, 2);
	// 		});
	// 		this.gstRegistrationForm.controls['state'].setValue(stat[0].stateid + "-" + stat[0].statename)
	// 	}
	// 	else {
	// 		this.gstRegistrationForm.controls['state'].setValue("")
	// 	}

	// }
	validateGSTNum(): ValidatorFn {

		return (control: AbstractControl): ValidationErrors | null => {
			let val = control.value;
			let stat = this.gs.getstates().filter((f) => {
				return f.stateid == val.substr(0, 2);
			});
			let ret = (val.length != 15 || !stat || stat.length == 0) ? { validateGSTNum: true } : null;

			return ret
		};
	}
	changeGST(e) {
		let statectrl=this.gstRegistrationForm.controls['state']		
		if (e.target.value.length == 15) {
			let stat = this.gs.getstates().filter((f) => {
				return f.stateid == e.target.value.substr(0, 2);
			});
			if (stat && stat.length > 0){
				statectrl.setValue(stat[0].stateid + "-" + stat[0].statename)

			}
			else
			statectrl.setValue("")
		}
		else {
			statectrl.setValue("")
		}
		statectrl.markAsTouched()

	}
	fileEvent(event): any {

		var file = event.target.files[0];
		this.photoName = file.name;

		var allowedExtensions =
			["jpg", "pdf", "jpeg", "png", "jfif", "bmp", "svg"];
		this.fileExtension = this.photoName.split('.').pop();

		if (this.isInArray(allowedExtensions, this.fileExtension)) {
			this.fileExtensionError = false;
			this.fileExtensionMessage = ""
			alert("Invalid File 1 formate");
		} else {
			this.fileExtensionMessage = "Only photos allowed!!"
			alert("Invalid File 2 formate");
			this.fileExtensionError = true;
		}

		if (file) {
			var reader = new FileReader();
			reader.onloadend = (e: any) => {
				var contents = e.target.result;
				this.photoContent = contents;
			}
			reader.readAsDataURL(file);
		} else {
			alert("Failed to load file");
		}
	}

	/*- checks if word exists in array -*/
	isInArray(array, word) {
		return array.indexOf(word.toLowerCase()) > -1;
	}
	// For File upload 
	onChangeFileUpload(event) {

		this.myfiles = event.target.files;
		var file = event.target.files[0];
		this.photoName = file.name;
    this.photoName = file.name;
    let fileNameArr = this.photoName.split('.')
		if(fileNameArr.length>2){
      // this.fileDoubleExtensionError = true
      this.$modal.errorModal({
        title: 'GST Registration',
        msg: 'File with double extension is not allowed!' 
      })
      this.resetKYC()
    }else{
      console.log("the size is ", file.size)
      if (file.size > 4000000) {
        console.log("The size is more ")
        this.fileSizeError1 = true;
      }
      else {
        this.fileSizeError1 = false;
      }
      if (file.size <= 0) {
        console.log("The size is less ")
        this.fileSizeError2 = true;
      }
      else {
        this.fileSizeError2 = false;
      }
      var allowedExtensions =
        ["jpg", "pdf", "jpeg", "png", "jfif", "bmp", "svg"];
      this.fileExtension = this.photoName.split('.').pop();
      console.log("this.photoName   ----------- ", this.photoName)
  
      if (this.isInArray(allowedExtensions, this.fileExtension)) {
        this.fileExtensionError = false;
        this.fileExtensionMessage = ""
      } else {
        this.fileExtensionMessage = "Only photos allowed!!"
        this.fileExtensionError = true;
      }
  
      if (file) {
        var reader = new FileReader();
        reader.onloadend = (e: any) => {
          var contents = e.target.result;
          this.photoContent = contents;
        }
        reader.readAsDataURL(file);
      } else {
        alert("Failed to load file");
      }
      console.log("this is file extension error", this.fileExtensionError);
    }
	}


	/*onChangeDataSource(res) {
		this.gstRegistrationForm.controls['entity_id'].setValue(res.message.EntityID)

	}*/
	reset() {

		this.resetKYC();
		this.gstRegistrationForm.reset();
		this.gstRegistrationForm.controls['entity_id'].setValue(this.gstmodel.entity_id);
		//this.gstRegistrationForm.controls['entity_id'].setValue(this.gstmodel.entity_id);
		this.gstRegistrationForm.controls['entity_legalname'].setValue(this.gstmodel.entity_legalname);
		this.gstRegistrationForm.controls['email_id'].setValue(this.gstmodel.email_id);


	}
	//for Form submition


	/*onChangeRootVal() {
		this.rootVal = this.pePrefix + this.identifiedVal;
	}*/

	onSubmit() {


			this.submitted = true;

			if (this.gstRegistrationForm.invalid || this.fileExtensionError || this.fileSizeError1 || this.fileSizeError2) {
				this.disableForm = true;
				let invalid = [];
				let controls = this.gstRegistrationForm.controls;
				for (const name in controls) {
					if (controls[name].invalid) {
						invalid.push(name);
					}
				}
				return;
			}
		//	if(confirm( "Are you sure you want to continue ! "))
		//	{
			this.GSTRegistration();
		//	}

	}

	GSTRegistration() {
		let EntityID = this.gstRegistrationForm.get("entity_id").value;
		let EntityLegalName = this.gstRegistrationForm.get("entity_legalname").value;
		let GSTNumber = this.gstRegistrationForm.get("gst_number").value;
		let Address = this.gstRegistrationForm.get("address").value;
		let Location = this.gstRegistrationForm.get("location").value;
		let State = this.gstRegistrationForm.get("state").value;
		let Pincode = this.gstRegistrationForm.get("pincode").value;
		let EmailID = this.gstRegistrationForm.get("email_id").value;
		let EntityComments = this.gstRegistrationForm.get("entity_comments").value;
		const GSTRegForm: FormData = new FormData();
		/*	let gstRegistrationdata = {
				'Entity_ID': EntityID,
				'CustLegalName': EntityLegalName,
				'Entity_GST_Id': GSTNumber,
				'Entity_Addr': Address,
				'Entity_City': Location,
				'Entity_State': State,
				'Entity_Pincode': Pincode,
				'Entity_EmailID': EmailID,
				'EntityComments': EntityComments,
				'StateGSTSeqNum': 12,
				'GSTfile': 123
			} */

		GSTRegForm.append('Entity_ID', EntityID);
		GSTRegForm.append('CustLegalName', EntityLegalName);
		GSTRegForm.append('Entity_GST_Id', GSTNumber);
		GSTRegForm.append('Entity_Addr', Address);
		GSTRegForm.append('Entity_City', Location);
		GSTRegForm.append('Entity_State', State.split("-")[1]);
		GSTRegForm.append('Entity_Pincode', Pincode);
		GSTRegForm.append('Entity_EmailID', EmailID);
		GSTRegForm.append('EntityComments', EntityComments);
		GSTRegForm.append('StateGSTSeqNum', State.split("-")[0]);
		const file1: any = document.getElementById('GSTfile');
		GSTRegForm.append('GSTfile', file1.files[0]);


		this.gs.verifyRegistration(GSTNumber)
			.subscribe(r => {
				console.log(r)
				if (r.status == 'failed') {
					this.$modal.errorModal({
						title: 'GST New Registration',
						msg: r.message
					})

				}
				else if (r.status == 'error') {
					this.$modal.errorModal({
						title: 'GST New Registration',
						msg: 'Error in GST Registration'
					})
				}

				else {

					this.gs.newgstRegistration(GSTRegForm)
						.subscribe(r => {
							console.log(r)
							if (r.URN && r.URN > 0) {
								//this.showSumbit = false
								this.$modal.successModal({
									title: 'GST New Registration',
									msg: "Your Request No(URN) " + r.URN + " is submitted for approval. You will receive an email on status within 24working hours. You can visit 'Search GST Registration'."
								})
								this.isValid = true;
								this.db.set(Constants.SESSSION_STORAGE, Constants.URNFORGST, r.URN);
								this.router.navigate(['gstregistration-details']);
								// this.router.navigate(['payment-submit'])
							}
							else {
								if (r.message && r.status == "failed") {
									//this.showSumbit = false
									this.$modal.errorModal({
										title: 'GST New Registration',
										msg: r.message
									})
								}

								else {
									this.$modal.errorModal({
										title: 'GST New Registration',
										msg: r.message + 'Error updating New Registration!'
									})
								}
							}

						});
				}
			});
	}
	resetKYC() {
		this.fileExtensionError = false;
		this.fileSizeError1 = false;
		this.fileSizeError2 = false;
		console.log(this.gstRegistrationForm.controls['uploader'].value);
		this.gstRegistrationForm.controls['uploader'].reset();
		console.log(this.gstRegistrationForm.controls['uploader'].value);

	}

}
